import React from 'react';

import { GuideSectionTypes } from '../../components';

import { EuiCode, EuiStat } from '../../../../src/components';
import statConfig from './playground';

import Stat from './stat';
const statSource = require('!!raw-loader!./stat');
const statSnippet = `<EuiStat
  title="22,123"
  description="Total people"
/>
`;

import StatColors from './stat_colors';
const statColorsSource = require('!!raw-loader!./stat_colors');
const statColorSnippet = `<EuiStat
  title="22,123"
  description="Total people"
  color="primary"
/>
`;

import StatAlign from './stat_align';
const statAlignSource = require('!!raw-loader!./stat_align');
const statAlignSnippet = `<EuiStat
  title="22,123"
  description="Total people"
  textAlign="right"
/>
`;

import StatSize from './stat_size';
const statSizeSource = require('!!raw-loader!./stat_size');
const statSizeSnippet = `<EuiStat
  title="22,123"
  description="Total people"
  titleSize="s"
/>
`;

import StatOrder from './stat_order';
const statOrderSource = require('!!raw-loader!./stat_order');
const statOrderSnippet = `<EuiStat
  title="22,123"
  description="Total people"
  reverse
/>
`;

import StatCombos from './stat_combos';
const statCombosSource = require('!!raw-loader!./stat_combos');

import StatLoading from './stat_loading';
const statLoadingSource = require('!!raw-loader!./stat_loading');
const statLoadingSnippet = `<EuiStat
  title={someNumber}
  description="Total people"
  isLoading={someNumber == undefined}
/>
`;

export const StatExample = {
  title: 'Stat',
  sections: [
    {
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statSource,
        },
      ],
      text: (
        <p>
          <strong>EuiStat</strong> can be used to display prominent text or
          number values. It consists of <EuiCode>title</EuiCode>
          and <EuiCode>description</EuiCode> elements with several visual
          styling properties (examples below).
        </p>
      ),
      props: { EuiStat },
      demo: <Stat />,
      snippet: statSnippet,
      playground: statConfig,
    },
    {
      title: 'Color variants',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statColorsSource,
        },
      ],
      text: (
        <p>
          <EuiCode>title</EuiCode> can be altered using the color property. By
          default, it will appear in <EuiCode>full</EuiCode> color. For proper
          color contrast, only a limited set of EUI colors are offered. See the
          Props tab above for a list of available colors.
        </p>
      ),
      snippet: statColorSnippet,
      demo: <StatColors />,
    },
    {
      title: 'Text alignment',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statAlignSource,
        },
      ],
      text: (
        <p>
          <strong>EuiStat</strong> also offers alignment options. By default,
          text will be left aligned.
        </p>
      ),
      snippet: statAlignSnippet,
      demo: <StatAlign />,
    },
    {
      title: 'Title size',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statSizeSource,
        },
      ],
      text: (
        <p>
          <EuiCode>title</EuiCode> uses the <strong>EuiTitle</strong> component
          and thus uses the same sizing property values (applied via the{' '}
          <EuiCode>titleSize</EuiCode> property). Although all{' '}
          <strong>EuiTitle</strong> sizes are available, suggested sizes include{' '}
          <EuiCode language="ts">
            {"'l' | 'm' | 's' | 'xs' | 'xxs' | 'xxxs'"}
          </EuiCode>
          . By default, the size is set to large{' '}
          <EuiCode language="ts">{"'l'"}</EuiCode>. The{' '}
          <EuiCode>description</EuiCode> label cannot be re-sized via component
          properties.
        </p>
      ),
      snippet: statSizeSnippet,
      demo: <StatSize />,
    },
    {
      title: 'Reverse the order',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statOrderSource,
        },
      ],
      text: (
        <p>
          You can reverse the order of the <EuiCode>description</EuiCode> and{' '}
          <EuiCode>title</EuiCode> text by setting the{' '}
          <EuiCode>reverse</EuiCode> property to true. By default, the
          description (label) is displayed above the title (value).
        </p>
      ),
      snippet: statOrderSnippet,
      demo: <StatOrder />,
    },
    {
      title: 'Stat loading',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statLoadingSource,
        },
      ],
      text: (
        <p>
          If you apply the <EuiCode>isLoading</EuiCode> prop, the title will
          indicate the loading status by swapping the provided title with two
          flashing dashes.
        </p>
      ),
      snippet: statLoadingSnippet,
      demo: <StatLoading />,
    },
    {
      title: 'Component variants',
      source: [
        {
          type: GuideSectionTypes.JS,
          code: statCombosSource,
        },
      ],
      text: (
        <p>
          In the following example, you can see variants of how the{' '}
          <strong>EuiStat</strong> component can be assembled. This component is
          very helpful for constructing single-value visualizations and
          summaries for different dashboards and page layouts and for
          communicating trends over time.
        </p>
      ),
      demo: <StatCombos />,
    },
  ],
};
